import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Card, Col } from "react-bootstrap";

//
import ChangeEmailModal from "./ChangeEmailModal";

function ChangeEmail({user}) {
  return (
    <Col md={6} className="change-email security-item">
      <Card className="bordered">
        <Card.Body>
          <header>
            <h5>Would you like to change your registered email? ✉️</h5>
          </header>

          <footer>
            <p>
              Current email : <span>{user.email}</span>
            </p>

            <ChangeEmailModal/>
          </footer>
        </Card.Body>
      </Card>
    </Col>
  );
}

ChangeEmail.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.userReducer.user
})

export default connect(mapStateToProps)(ChangeEmail);
